import { render, staticRenderFns } from "./PerformanceValuesReport.vue?vue&type=template&id=80b59770&scoped=true&"
import script from "./PerformanceValuesReport.vue?vue&type=script&lang=js&"
export * from "./PerformanceValuesReport.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceValuesReport.vue?vue&type=style&index=0&id=80b59770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b59770",
  null
  
)

export default component.exports